module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-127-retro.d716b2e8.jpg";